import { render, staticRenderFns } from "./BenefitsMobile.vue?vue&type=template&id=f3a8f2fc&scoped=true"
import script from "./BenefitsMobile.vue?vue&type=script&lang=js"
export * from "./BenefitsMobile.vue?vue&type=script&lang=js"
import style0 from "./BenefitsMobile.vue?vue&type=style&index=0&id=f3a8f2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a8f2fc",
  null
  
)

export default component.exports